import React from 'react';
import { ShieldCheck, Heart, Users } from 'lucide-react';

/**
 * "How Nia works" card — premium variant uses paper surface with subtle
 * clay accents per the v1 design spec. The compact inline variant is for
 * places where space is tight (e.g. small disclaimer bands).
 */
export default function HowNiaWorks({ variant = 'card' }) {
    if (variant === 'inline') {
        return (
            <div
                style={{
                    background: 'var(--nia-clay-tint)',
                    borderRadius: 14,
                    padding: 12,
                    fontSize: 12,
                    color: 'var(--nia-ink)',
                    lineHeight: 1.55,
                    display: 'flex',
                    gap: 10,
                    alignItems: 'flex-start',
                    border: '1px solid rgba(14, 90, 79, 0.20)',
                }}
            >
                <ShieldCheck size={16} color="var(--nia-clay)" style={{ flexShrink: 0, marginTop: 2 }} />
                <div>
                    <b style={{ color: 'var(--nia-clay)' }}>How Nia works.</b> Nia is family-support coordination software. We help diaspora families plan, track, and stay aligned on what loved ones back home need — Nia is a planning tool, not a bank, lender, or money transfer service.
                </div>
            </div>
        );
    }
    return (
        <div
            className="nia-card"
            style={{ padding: 18, background: 'var(--nia-paper)' }}
            data-testid="how-nia-works-card"
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
                <div
                    style={{
                        width: 32,
                        height: 32,
                        borderRadius: 10,
                        background: 'var(--nia-clay-tint)',
                        color: 'var(--nia-clay)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <ShieldCheck size={16} />
                </div>
                <div
                    className="font-display"
                    style={{
                        fontWeight: 700,
                        fontSize: 15,
                        color: 'var(--nia-ink)',
                        letterSpacing: '-0.015em',
                    }}
                >
                    How Nia works
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                <Row
                    Icon={Users}
                    title="We connect families"
                    sub="Senders abroad and loved ones back home, on one trusted coordination platform."
                />
                <Row
                    Icon={Heart}
                    title="We help you plan & track"
                    sub="Family obligations, reminders, receipts, and status updates — all in one place."
                />
            </div>
        </div>
    );
}

function Row({ Icon, title, sub }) {
    return (
        <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
            <div
                style={{
                    width: 32,
                    height: 32,
                    borderRadius: 10,
                    background: 'var(--nia-muted)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                }}
            >
                <Icon size={15} color="var(--nia-sage)" />
            </div>
            <div>
                <div
                    style={{
                        fontWeight: 600,
                        fontSize: 13,
                        color: 'var(--nia-ink)',
                        letterSpacing: '-0.005em',
                    }}
                >
                    {title}
                </div>
                <div
                    style={{
                        fontSize: 12,
                        color: 'var(--nia-text-muted)',
                        lineHeight: 1.5,
                        marginTop: 3,
                    }}
                >
                    {sub}
                </div>
            </div>
        </div>
    );
}
